import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Notes } from '@app/core/Enum/note';
import { CommonService } from '@app/core/Services';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-note30',
  templateUrl: './note30.component.html',
  styleUrls: ['./note30.component.scss'],
})
export class Note30Component implements OnInit {
  note30Form: FormGroup;
  calculativeData: any;

  @Input() triggerEditData: Observable<any>;

  constructor(public commonService: CommonService) {}

  ngOnInit(): void {
    this.setForm();
    this.triggerEditData?.subscribe((data) => {
      if (data.noteId === Notes.Note30) {
        this.calculativeData = data.response.calculativeData;
        if (
          data.response.userInputData !== null &&
          data.response.userInputData !== undefined &&
          data.response.userInputData.data !== null &&
          data.response.userInputData.data !== undefined
        ) {
          this.editNotes30(data.response.userInputData.data);
        }
      }
    });
  }

  editNotes30(res): void {
    this.note30Form.patchValue({
      textbox1: res.textbox1 ? res.textbox1 : ' ',
    });
  }

  setForm(): void {
    this.note30Form = new FormGroup({
      textbox1: new FormControl(''),
    });
  }
}
